export default __webpack_public_path__ + "static/media/outlookCalendar.8f324c3b.svg";